module.exports = __webpack_public_path__ + "static/media/Edge.a789cf0e.png";